import React, { useState, useEffect } from 'react';
import { Mail, Phone, Award, GraduationCap, Briefcase, Scale, Users } from 'lucide-react';
import ContactFormModal from '../components/ContactFormModal';

const MeetAttorneyPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    document.title = "Meet Our Legal Team - IP Partners Inc";
  }, []);

  const attorneys = [
    {
      id: 1,
      name: "David Allen Matthews",
      title: "Senior Partner",
      specialization: "Intellectual Property & Trademark Strategy",
      education: "University of the Pacific, McGeorge School of Law, J.D.",
      barAdmission: "State Bar of California (No. 196906), North Carolina State Bar, U.S. District Courts for all districts in NC and CA",
      experience: "Over 25 years",
      bio: "David is a highly accomplished legal strategist with nearly three decades of experience helping businesses secure their competitive edge. Admitted to the California Bar in 1998, he has spent his career at the intersection of technology and intellectual property, advising clients on the complexities of trademark registration and brand protection in a global marketplace. David’s expertise extends beyond simple filings; he serves as a comprehensive counselor for startups and established enterprises, guiding them through business entity formation, master service agreements, and sophisticated IP audits. His approach is rooted in the belief that a robust legal foundation—anchored by strong trademark and data privacy protections—is the primary driver of long-term business value. Throughout his distinguished career, he has successfully navigated complex trademark and commercial disputes for a diverse range of technology and service-based firms, developed enterprise level IP and software licensing frameworks for international corporations, and has been recognized by Best Lawyers in America for his outstanding excellence in business law and strategic transactions.",
      expertise: [
        "Commercial Technology Transactions",
        "Trademark Prosecution",
        "Strategic Business Counseling",
        "Trademark Registration & Maintenance",
        "SaaS and Technology Licensing",
        "Business Formation & Corporate Governance",
        "Intellectual Property Enforcement",
        "Data Privacy & Security Compliance ",
        
      ]
    },
    {
      id: 2,
      name: "Cathy G. Renken",
      title: "Attorney",
      specialization: "Corporate Law & Business Transactions",
      education: "University of California, Berkeley School of Law, J.D.",
      barAdmission: "California Bar, Texas Bar",
      experience: "18+ years",
      bio: "Cathy G. Renken is a distinguished corporate attorney with nearly two decades of experience advising businesses on complex transactional matters. Her practice encompasses business formation, contract negotiation, mergers and acquisitions, and corporate governance. Cathy has represented Fortune 500 companies, mid-sized enterprises, and startups across diverse industries including technology, healthcare, and manufacturing. She is known for her strategic approach to structuring deals that maximize value while minimizing risk. Throughout her career, Cathy has successfully closed transactions valued at over $2 billion and has been recognized as a leading corporate attorney by multiple legal publications. She takes pride in building long-term relationships with clients and serving as a trusted business advisor beyond legal matters.",
      expertise: [
        "Corporate Governance",
        "Mergers & Acquisitions",
        "Contract Negotiation",
        "Business Formation",
        "Securities Compliance",
        "Corporate Finance"
      ]
    },
    {
      id: 3,
      name: "Tony V. Acevedo",
      title: "Attorney",
      specialization: "Intellectual Property & Technology Law",
      education: "Stanford Law School, J.D.; MIT, B.S. Computer Science",
      barAdmission: "California Bar, Federal Circuit, USPTO",
      experience: "15+ years",
      bio: "Tony V. Acevedo brings a unique combination of legal expertise and technical knowledge to his intellectual property practice. With an engineering background from MIT and law degree from Stanford, Tony specializes in protecting innovations for technology companies, software developers, and research institutions. His practice focuses on patent prosecution, trademark registration, copyright matters, and technology licensing. Tony has secured hundreds of patents for clients ranging from individual inventors to major technology corporations. He regularly counsels clients on IP strategy, portfolio management, and enforcement actions. Tony's technical fluency allows him to quickly grasp complex inventions and craft patent applications that provide robust protection. He has successfully defended clients in IP litigation and negotiated favorable licensing agreements generating millions in revenue. Tony is a frequent speaker at technology and IP conferences.",
      expertise: [
        "Patent Prosecution",
        "Trademark Registration",
        "Copyright Law",
        "Technology Licensing",
        "IP Litigation",
        "Trade Secret Protection"
      ]
    },
    {
      id: 4,
      name: "Ramon K. Masters",
      title: "Attorney",
      specialization: "Regulatory Compliance & Government Contracting",
      education: "Georgetown University Law Center, J.D.; George Washington University, M.P.A.",
      barAdmission: "D.C. Bar, California Bar, Maryland Bar",
      experience: "20+ years",
      bio: "Ramon K. Masters is a preeminent authority on regulatory compliance and government contracting with over two decades of experience navigating complex legal frameworks. His practice encompasses anti-corruption compliance, FCPA matters, government contract negotiation, and regulatory investigations. Ramon previously served as compliance counsel for a Fortune 100 defense contractor and brings insider knowledge of government procurement processes. He advises multinational corporations on developing comprehensive compliance programs that meet FCPA, FAR, and DFARS requirements. Ramon has conducted internal investigations, represented clients before regulatory agencies, and negotiated favorable resolutions in enforcement actions. His government contracting practice includes bid protests, claims litigation, and contract disputes. Ramon has helped clients secure and maintain government contracts worth hundreds of millions of dollars while ensuring full regulatory compliance. He is recognized as a thought leader in compliance and regularly contributes to legal journals.",
      expertise: [
        "FCPA Compliance",
        "Government Contracting",
        "FAR/DFARS Compliance",
        "Regulatory Investigations",
        "Internal Audits",
        "Risk Management"
      ]
    },
    {
      id: 5,
      name: "James Lee Michaels",
      title: "Attorney",
      specialization: "Regulatory Compliance & Government Contracting",
      education: "Georgetown University Law Center, J.D., 2010; B.S. Electrical Engineering, University of Virginia, 2007",
      barAdmission: "Virginia State Bar, District of Columbia Bar, USPTO (Patent Bar)",
      experience: "Over a decade",
      bio: "James Lee Michaels is a seasoned intellectual property expert with a strong technical background, advising clients on patent prosecution, trademark portfolio strategy, and trade secret protection. He has helped startups and established enterprises secure and enforce their IP rights across domestic and international markets, and regularly counsels on IP due diligence in mergers and acquisitions. Secured patent protection for innovative technologies across multiple industries. Successfully litigated high-profile trademark infringement cases. Recognized as a Rising Star in Intellectual Property by Super Lawyers.",
      expertise: [
        "Patent Prosecution",
        "Trademark Strategy",
        "Trade Secret Litigation",
        "IP Portfolio Management",
        
      ]
    }
    
  ];

  const paralegals = [
    {
      id: 1,
      name: "Norma R. Campbell",
      title: "Paralegal",
      specialization: "Corporate & Business Law",
      bio: "Norma has over 12 years of paralegal experience supporting corporate transactions and business formation matters. She expertly manages due diligence processes, prepares corporate documents, and coordinates complex closings with exceptional attention to detail."
    },
    {
      id: 2,
      name: "Virginia R. Keller",
      title: "Paralegal",
      specialization: "Intellectual Property",
      bio: "Virginia specializes in IP portfolio management with 10 years of experience. She handles trademark applications, patent filings, and copyright registrations while maintaining meticulous records and monitoring deadlines to ensure clients' IP assets remain protected."
    },
    {
      id: 3,
      name: "Christine P. Schmidt",
      title: "Paralegal",
      specialization: "Compliance & Regulatory",
      bio: "Christine brings 14 years of experience supporting compliance programs and regulatory matters. She conducts research, prepares compliance documentation, and assists with internal investigations, demonstrating exceptional organizational skills and discretion."
    },
    {
      id: 4,
      name: "Lane J. Jones",
      title: "Paralegal",
      specialization: "Litigation & Contract Management",
      bio: "Lane has 8 years of paralegal experience in litigation support and contract administration. He excels at document management, discovery coordination, and contract database maintenance, providing reliable support for complex legal matters."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-brown-100 to-brown-50 pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-brown-900 mb-4">
            Meet Our Legal Team
          </h1>
          <p className="text-xl text-brown-700 max-w-3xl mx-auto">
            Experienced attorneys and dedicated paralegals committed to delivering exceptional legal services and achieving outstanding results for our clients
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-lg text-brown-700 leading-relaxed mb-6">
            Our legal team brings decades of combined experience across multiple practice areas, providing clients 
            with sophisticated legal counsel and strategic guidance. Each member is dedicated to understanding your 
            unique needs and delivering personalized solutions.
          </p>
          <p className="text-lg text-brown-700 leading-relaxed">
            Licensed across multiple jurisdictions and recognized for their expertise, our attorneys and paralegals 
            stay at the forefront of legal developments to provide innovative, effective representation.
          </p>
        </div>
      </section>

      {/* Attorneys Section */}
      <section className="py-16 bg-brown-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-brown-900 text-center mb-12">Our Attorneys</h2>
          
          <div className="space-y-8">
            {attorneys.map((attorney) => (
              <div key={attorney.id} className="bg-white rounded-xl shadow-lg p-8 border border-brown-200">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  {/* Left: Name and Title */}
                  <div className="lg:col-span-1">
                    <div className="sticky top-24">
                      <h3 className="text-2xl font-bold text-brown-900 mb-2">{attorney.name}</h3>
                      <p className="text-lg text-brown-700 font-semibold mb-4">{attorney.title}</p>
                      <div className="bg-brown-100 px-4 py-2 rounded-lg inline-block mb-6">
                        <p className="text-sm font-medium text-brown-800">{attorney.specialization}</p>
                      </div>

                      <div className="space-y-4">
                        <div className="flex items-start space-x-3">
                          <GraduationCap className="w-5 h-5 text-brown-600 flex-shrink-0 mt-1" />
                          <div>
                            <p className="text-xs font-semibold text-brown-900 uppercase mb-1">Education</p>
                            <p className="text-sm text-brown-700">{attorney.education}</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <Scale className="w-5 h-5 text-brown-600 flex-shrink-0 mt-1" />
                          <div>
                            <p className="text-xs font-semibold text-brown-900 uppercase mb-1">Bar Admission</p>
                            <p className="text-sm text-brown-700">{attorney.barAdmission}</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <Briefcase className="w-5 h-5 text-brown-600 flex-shrink-0 mt-1" />
                          <div>
                            <p className="text-xs font-semibold text-brown-900 uppercase mb-1">Experience</p>
                            <p className="text-sm text-brown-700">{attorney.experience}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right: Bio and Expertise */}
                  <div className="lg:col-span-2 space-y-6">
                    <div>
                      <h4 className="text-lg font-semibold text-brown-900 mb-3">Biography</h4>
                      <p className="text-brown-700 leading-relaxed">{attorney.bio}</p>
                    </div>

                    <div>
                      <h4 className="text-lg font-semibold text-brown-900 mb-4">Areas of Expertise</h4>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {attorney.expertise.map((item, idx) => (
                          <div key={idx} className="flex items-center space-x-2 bg-brown-50 px-4 py-2 rounded-lg">
                            <Award className="w-4 h-4 text-brown-600 flex-shrink-0" />
                            <span className="text-sm text-brown-800 font-medium">{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Paralegals Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-brown-900 text-center mb-4">Our Paralegals</h2>
          <p className="text-center text-brown-700 mb-12 max-w-3xl mx-auto">
            Our skilled paralegals provide essential support, ensuring efficient case management and exceptional client service
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {paralegals.map((paralegal) => (
              <div key={paralegal.id} className="bg-brown-50 rounded-xl p-6 border border-brown-200 shadow-md">
                <div className="flex items-start space-x-4">
                  <div className="bg-brown-200 p-3 rounded-lg">
                    <Users className="w-8 h-8 text-brown-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-brown-900 mb-1">{paralegal.name}</h3>
                    <p className="text-sm text-brown-600 font-semibold mb-2">{paralegal.title}</p>
                    <div className="bg-brown-100 px-3 py-1 rounded inline-block mb-3">
                      <p className="text-xs font-medium text-brown-800">{paralegal.specialization}</p>
                    </div>
                    <p className="text-brown-700 leading-relaxed">{paralegal.bio}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Work With Us */}
      <section className="py-20 bg-brown-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-brown-900 text-center mb-12">
            Why Work With Our Team
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl text-center shadow-md">
              <Scale className="w-16 h-16 text-brown-700 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-brown-900 mb-3">Deep Expertise</h3>
              <p className="text-brown-700">
                Decades of combined experience across multiple practice areas and industries
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl text-center shadow-md">
              <Award className="w-16 h-16 text-brown-700 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-brown-900 mb-3">Proven Results</h3>
              <p className="text-brown-700">
                Track record of successful outcomes for individuals and businesses nationwide
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl text-center shadow-md">
              <Briefcase className="w-16 h-16 text-brown-700 mx-auto mb-4" />
              <h3 className="text-xl font-bold text-brown-900 mb-3">Client-Focused</h3>
              <p className="text-brown-700">
                Personalized attention and strategic counsel tailored to your specific needs
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-brown-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Ready to Work With Our Team?
          </h2>
          <p className="text-xl text-brown-200 mb-8">
            Schedule a consultation with our experienced legal team today
          </p>
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-brown-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-brown-700 transition-colors duration-200 shadow-lg"
          >
            Schedule Consultation
          </button>
          <div className="mt-8 flex items-center justify-center space-x-8 text-brown-200">
            <div className="flex items-center space-x-2">
              <Phone className="w-5 h-5" />
              <a href="tel:+18332017574" className="hover:text-white transition-colors">
                +1 (833) 201-7574
              </a>
            </div>
            <div className="flex items-center space-x-2">
              <Mail className="w-5 h-5" />
              <a href="mailto:info@ippartnerinc.com" className="hover:text-white transition-colors">
                info@ippartnerinc.com
              </a>
            </div>
          </div>
        </div>
      </section>

      <ContactFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default MeetAttorneyPage;
